module.exports = __webpack_public_path__ + "img/freelancer-hiring-1.72359494.png";